const productCards = document.querySelectorAll(".custom-product-card");
let moneyFormat = document.querySelector(".home-collection").dataset.moneyFormat;

for (var i = 0; i < productCards.length; i++) {
  const current = productCards[i];
  const product = JSON.parse(current.dataset.product);
  const sectionId = current.dataset.sectionId;
  const uniqueID = sectionId + "-" + product.id;
  try {
    var selectCallback = function(variant, selector) {
      if (variant) {
        var inventoryQuantity = $('#product-select-' + uniqueID).find(":selected").attr("data-quantity");
        var inventoryPolicy = $('#product-select-' + uniqueID).find(":selected").attr("data-policy");
        const addToCartContainer = jQuery('#add-to-cart-inner-container-' + uniqueID);
        
        if (variant.available) {
          addToCartContainer.removeClass('disabled');
          addToCartContainer.find('#submit').removeClass('disabled').prop('disabled', false).val("Add to Bag");
        } else {
          addToCartContainer.addClass('disabled');
          addToCartContainer.find('#submit').val("Sold Out").addClass('disabled').prop('disabled', true).removeClass("back-order-button");     
        }
        
        jQuery('#product-price-' + uniqueID).html(Shopify.formatMoney(variant.price, moneyFormat));    
    
      } else {
        jQuery('#backorder').addClass('hidden');
        $("#add").removeClass("disabled").prop('disabled', false);
      }
    };
    
    new Shopify.OptionSelectors('product-select-' + uniqueID, { product: product, onVariantSelected: selectCallback });
  
    if (! (product.variants.size == 1 && product.variants.first.title.includes('Default'))) {
      const firstSelector = $('#product-select-' + uniqueID + '-option-0');
      const secondSelector = $('#product-select-' + uniqueID + '-option-1');
      
      if (firstSelector){
        firstSelector.prepend('<option value="" disabled selected>Size</option>');
      }
      if (secondSelector){
        secondSelector.prepend('<option value="" disabled selected>Colour</option>');
      }
    }
    
  } catch (error) {
    console.log("Product Invalid")
  }
}
